export const clientTimeZoneOffset = -(new Date().getTimezoneOffset());